import { useEffect, useRef } from 'react';
import mermaid from 'mermaid';
import { MermaidSection } from '@/types';

interface MermaidRendererProps {
  section: MermaidSection;
}

// Initialize mermaid
mermaid.initialize({
  startOnLoad: false,
  theme: 'dark',
  securityLevel: 'loose',
});

export function MermaidRenderer({ section }: MermaidRendererProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const renderDiagram = async () => {
      try {
        const id = `mermaid-${Math.random().toString(36).substr(2, 9)}`;
        const { svg } = await mermaid.render(id, section.data.content);

        if (containerRef.current) {
          containerRef.current.innerHTML = svg;
        }
      } catch (error) {
        console.error('Failed to render mermaid diagram:', error);
        if (containerRef.current) {
          containerRef.current.innerHTML = `
            <div class="text-red-500 p-4 border border-red-300 rounded">
              Failed to render diagram: ${error instanceof Error ? error.message : 'Unknown error'}
            </div>
          `;
        }
      }
    };

    renderDiagram();
  }, [section.data.content]);

  return (
    <div className="p-6 bg-card border border-border rounded-lg">
      <div ref={containerRef} className="flex justify-center items-center" />
    </div>
  );
}
